import { memo } from 'react';
import { Typography, Box } from '@mui/material';
import { getWireDriverIcons } from 'screens/syndication/utility';
import { useChannelsSearch } from 'screens/syndication/views/search/channels/ChannelsSearchWithContext';

export const SyndicationDriverField = memo(({ record }: any) => {
  const { driverData } = useChannelsSearch();

  const driverValue = record?.driver;
  const driverLabel = driverData.find(
    (driver: any) => driver.value === driverValue,
  )?.label;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        gap: 1,
      }}
    >
      {getWireDriverIcons(driverValue, 14)}
      <Typography component="span">{driverLabel}</Typography>
    </Box>
  );
});

SyndicationDriverField.displayName = 'SyndicationDriverField';

export default SyndicationDriverField;
